import { Provider } from "@redotech/redo-model/order";
import { ProductInfo, ProductStatus } from "@redotech/redo-model/product";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const searchProducts = {
  name: "searchProducts" as const,
  input: z.object({
    searchString: z.string(),
    provider: createEnum(Provider),
    first: z.number().optional(),
    includeStatuses: z.array(createEnum(ProductStatus)).optional(),
    countryCode: z.string().optional(),
  }),
  output: z.object({ products: z.array(ProductInfo) }),
};
